type CssWidthUnit = 'vw' | 'px'
type ContainerSize = `${number}${CssWidthUnit}`
export interface ContainerInfo {
  maxWidthAtMd: ContainerSize
  maxWidthAtLg: ContainerSize
  maxWidthAtXl: ContainerSize
}

export function divideContainerSize(value: ContainerSize, divideBy: number): ContainerSize {
  const res = Math.round(parseInt(value.slice(0, -2), 10) / divideBy)
  const unit = value.slice(value.length - 2) as CssWidthUnit
  return `${res}${unit}` as const
}
